export function Server() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="server-04">
        <path
          id="Icon"
          d="M14.6654 6.99935L14.3491 4.4691C14.225 3.47669 14.163 2.98048 13.9295 2.60655C13.7237 2.27709 13.4264 2.01469 13.074 1.85138C12.674 1.66602 12.1739 1.66602 11.1738 1.66602H4.8236C3.82346 1.66602 3.32339 1.66602 2.92338 1.85138C2.57095 2.01469 2.2737 2.27709 2.06794 2.60655C1.83439 2.98048 1.77236 3.47669 1.64831 4.4691L1.33203 6.99935M3.66536 9.66602H12.332M3.66536 9.66602C2.3767 9.66602 1.33203 8.62135 1.33203 7.33268C1.33203 6.04402 2.3767 4.99935 3.66536 4.99935H12.332C13.6207 4.99935 14.6654 6.04402 14.6654 7.33268C14.6654 8.62135 13.6207 9.66602 12.332 9.66602M3.66536 9.66602C2.3767 9.66602 1.33203 10.7107 1.33203 11.9993C1.33203 13.288 2.3767 14.3327 3.66536 14.3327H12.332C13.6207 14.3327 14.6654 13.288 14.6654 11.9993C14.6654 10.7107 13.6207 9.66602 12.332 9.66602M3.9987 7.33268H4.00536M3.9987 11.9993H4.00536M7.9987 7.33268H11.9987M7.9987 11.9993H11.9987"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
